import { FC, useEffect, useState } from 'react'
import { PropsImageWithFallback } from './types'

const ImageWithFallback: FC<PropsImageWithFallback> = ({
  src,
  alt = '',
  loading = 'lazy',
  decoding = 'async',
  title = '',
  fallback = '/static/not-foto.png',
  className = '',
  width = '',
}) => {
  const [imgSrc, setImgSrc] = useState(src || fallback)

  useEffect(() => {
    setImgSrc(src || fallback)
  }, [src, fallback])

  return (
    <img
      src={imgSrc}
      alt={alt}
      title={title}
      width={width}
      loading={loading}
      className={className}
      decoding={decoding}
      onError={() => setImgSrc(fallback)}
    />
  )
}

export default ImageWithFallback
